export default __webpack_public_path__ + "static/media/portfolio1.4b1c6ba7.png";